import Banana from "banana-i18n";
import { requestI18nFile } from "../features/requests";

interface TranslationState {
  banana? : Banana;
  loaded : boolean;
}
const translation : TranslationState = {
  banana: undefined,
  loaded: false
}

export async function loadI18n(path : string, lang : string) : Promise<void> {
  const data = await requestI18nFile(`${path + lang}.json`);
  if (!data) return;

  const banana = new Banana(lang);
  banana.load(data, lang);
  translation.banana = banana;
  translation.loaded = true;

  console.log(`Loaded i18n for ${lang}`);
}

export function translate(key : string, ...data : string[]) : string {
  if (translation.loaded && translation.banana) {
    return translation.banana.i18n(key, data);
  }
  return key;
}

export function getTranslationCfg() : any {
  return translation;
}

export function getOnboardingLocale() : any {
  return { back: translate("onboarding-back"),
           close: translate("onboarding-close"),
           last: translate("onboarding-last"),
           next: translate("onboarding-next"),
           open: translate("onboarding-open"),
           skip: translate("onboarding-skip")
         };
}
